module.exports = {
  "version": "0.27.2"
};